export const timeSince = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    
    var seconds = Math.floor((now.getTime() - date.getTime())  / 1000);

    var interval = seconds / 31536000;
    if (interval > 1) {
        return Math.floor(interval) + " years ago";
    }
    
    interval = seconds / 2592000;
    if (interval > 1) {
        return Math.floor(interval) + " months ago";
    }
    

    interval = seconds / 86400;
    if (interval > 1) {
        return Math.floor(interval) + " days ago";
    }
    
    interval = seconds / 3600;
    if (interval > 1) {
        return Math.floor(interval) + " hours ago";
    }
    
    interval = seconds / 60;
    if (interval > 1) {
        return Math.floor(interval) + " minutes ago";
    }
    
    return Math.floor(seconds) + " seconds ago";
}

export const nextDateDays = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();

    var timeDifference = Math.floor((date.getTime() - now.getTime()));
    var dayDifference = timeDifference / (1000 * 3600 * 24);

    dayDifference = Math.round(dayDifference);

    if (dayDifference > 1) {
        return " due in " + Math.floor(dayDifference) + " days";
    }
    else if (dayDifference == 1) {
        return " due tomorrow";
    }
    else if (dayDifference == 0) {
        return " due today";
    }
    else if (dayDifference < 0) {
        return " due " + Math.floor(dayDifference).toString().replace("-", "") + " days ago";
    }
  

    return " unknown";
}

export const nextDateDaysDashboard = (dateString: string) => {
    const date = new Date(dateString)
    const now = new Date();

    var timeDifference = Math.floor((date.getTime() - now.getTime()));
    var dayDifference = timeDifference / (1000 * 3600 * 24);

    dayDifference = Math.round(dayDifference);

    if (dayDifference > 1) {
        return Math.floor(dayDifference) + " days";
    }
    else if (dayDifference == 1) {
        return "Tomorrow";
    }
    else if (dayDifference == 0) {
        return "Today";
    }
    else if (dayDifference < 0) {
        return Math.floor(dayDifference).toString().replace("-", "") + " days ago";
    }


    return " unknown";
}

export const nextDateDaysTooltip = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();

    var timeDifference = Math.floor((date.getTime() - now.getTime()));
    var dayDifference = timeDifference / (1000 * 3600 * 24);

    dayDifference = Math.round(dayDifference);

    if (dayDifference > 1) {
        return "Due date: " + date.toDateString() ;
    }
    else if (dayDifference == 1) {
        return "Due date: " + date.toDateString();
    }
    else if (dayDifference == 0) {
        return "Due date: " + date.toDateString();
    }
    else if (dayDifference < 0) {
        return " LATE!! was due on " + date.toDateString();
    }


    return " unknown";
}

export const previousDateDays = (dateString: string) => {
    const date = new Date(dateString)
    const now = new Date();

    var timeDifference = Math.floor((date.getTime() - now.getTime()));
    var dayDifference = timeDifference / (1000 * 3600 * 24);

    dayDifference = Math.round(dayDifference);

    if (dayDifference > 1) {
        return " " + Math.floor(dayDifference) + " days ago";
    }
    else if (dayDifference == 1) {
        return " " + Math.floor(dayDifference) + " day ago";
    }
    else if (dayDifference == 0) {
        return " today";
    }
    else if (dayDifference < 0) {
        return " " + Math.floor(dayDifference).toString().replace("-", "") + " days ago";
    }


    return " unknown";
}

export const previousDateDaysTooltip = (dateString: string) => {
    const date = new Date(dateString)
    const now = new Date();

    var timeDifference = Math.floor((date.getTime() - now.getTime()));
    var dayDifference = timeDifference / (1000 * 3600 * 24);

    dayDifference = Math.round(dayDifference);

    if (dayDifference > 1) {
        return " Completed on date: " + date.toDateString();
    }
    else if (dayDifference == 1) {
        return " Completed on  date: " + date.toDateString();
    }
    else if (dayDifference == 0) {
        return " Completed on  date: " + date.toDateString();
    }
    else if (dayDifference < 0) {
        return " Completed on  on " + date.toDateString();
    }


    return " unknown";
}

export const colorDateTooltipOverdue = (dateString: string) => {
    const date = new Date(dateString)
    const now = new Date();

    var timeDifference = Math.floor((date.getTime() - now.getTime()));
    var dayDifference = timeDifference / (1000 * 3600 * 24);

    dayDifference = Math.round(dayDifference);

    if (dayDifference < 0) {
        return "red"
    }

        return "";
}

export const colorDateTooltipOverdueDashboard = (dateString: string) => {
    const date = new Date(dateString)
    const now = new Date();

    var timeDifference = Math.floor((date.getTime() - now.getTime()));
    var dayDifference = timeDifference / (1000 * 3600 * 24);

    dayDifference = Math.round(dayDifference);

    if (dayDifference < 0) {
        return "red"
    }
    if (dayDifference == 0) {
        return "green"
    }

    return "";
}

export const ActivityReady = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();

    var timeDifference = Math.floor((date.getTime() - now.getTime()));
    var dayDifference = timeDifference / (1000 * 3600 * 24);

    dayDifference = Math.round(dayDifference);

    return dayDifference;

}

export const ActivityColor = (dateString: string) => {
    const date = new Date(dateString)
    const now = new Date();

    var timeDifference = Math.floor((date.getTime() - now.getTime()));
    var dayDifference = timeDifference / (1000 * 3600 * 24);

    dayDifference = Math.round(dayDifference);

    if (dayDifference > 1) {
        return '';
    }
    else if (dayDifference == 1) {
        return '';
    }
    else if (dayDifference == 0) {
        return 'green';
    }
    else if (dayDifference < 0) {
        return 'orange';
    }


    return "";
}

export const formatDateLocal = (dateString: string) => {
    const date = new Date(dateString);

    if (date) {
        return date.toLocaleString();
    }
    else {
        return "";
    }
    
    
}


export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const days = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

export const formatDate = (date: Date) => {
    if (!date) return '';

    const year = date.getFullYear();
    const month = months[date.getMonth()];
    const day = days[date.getDay()];
    const dayOfMonth = date.getDate();

    return `${day} ${dayOfMonth}/${month}/${year.toString().substr(-2)}`;
};

export const stringToDate = (date: string | null) => date ? new Date(date) : null;